import { ITableListLegend } from 'src/app/interfaces/components/table.interface';
import { IContentAreaActionClick, TContentAreaAction } from 'src/app/interfaces/components/content-area.interface';
import { ISelectOption } from 'src/app/interfaces/components/select.interface';

export const contentAreaActions: IContentAreaActionClick<TContentAreaAction>[] = [
  { type: 'export', label: 'CONTENT_AREA.GENERATE_REPORT' },
  { type: 'add', label: 'EMPLOYEE_LIST.ADD_BUTTON' },
];

export const searchOptions: ISelectOption[] = [
  { value: 'name', label: 'EMPLOYEE_LIST.FILTERS.SEARCH_SELECT.NAME' },
  { value: 'document', label: 'EMPLOYEE_LIST.FILTERS.SEARCH_SELECT.DOCUMENT' },
  { value: 'position', label: 'EMPLOYEE_LIST.FILTERS.SEARCH_SELECT.POSITION' },
];

export const tableLegends: ITableListLegend[] = [
  { name: 'EMPLOYEE_LIST.TABLE.DOCUMENT', value: 'document', type: 'document' },
  { name: 'EMPLOYEE_LIST.TABLE.NAME', value: 'name' },
  { name: 'EMPLOYEE_LIST.TABLE.EMAIL', value: 'email' },
  { name: 'EMPLOYEE_LIST.TABLE.STATUS', value: 'tableStatus' },
];

export const displayedColumns = [
  'document',
  'name',
  'email',
  'tableStatus',
];
